import { BorderBox } from "@/components/atoms/BorderBox";
import { crmRegistry } from "@/features/crm_system/lib/_core/crmRegistry";
import { Grip } from "lucide-react";
import { DraggableCrmSystemItemProps } from ".";
import { cn } from "@/lib/utils";



export function DraggableCrmSystemItem({
    provided,
    isDragging,
    crmSystem,
    children,
    borderBoxClassName
}: Readonly<DraggableCrmSystemItemProps>) {
    const crmSystemConfig = crmRegistry.getSystemById(crmSystem);

    return (
        <BorderBox
            ref={provided.innerRef}
            {...provided.draggableProps}
            {...provided.dragHandleProps}
            className={cn(`flex items-center gap-2 border-l-4 min-w-0 ${isDragging ? 'opacity-50' : ''}`, borderBoxClassName)}
            size='sm'
            style={{
                borderLeftColor: crmSystemConfig?.branding.color,
                ...provided.draggableProps.style
            }}
        >
            <div className="flex-shrink-0">
                <Grip size={18} />
            </div>
            {children}
        </BorderBox>
    );
}